import { defineStore } from 'pinia';
import type { Search } from '@fibl/zdb-common';

/*
 * used for sup-offer-list in rdb
 * and request-list in oxs
 */
export const useOfferListStore = defineStore('offerList', {
	state: () => ({
		selected: [] as string[],
		inverted: false
	}),

	getters: {
		getFilter(): Search.SearchFilter {
			let or = {
				$or: this.selected.map(id => ({
					field: '/id',
					comparison: 'eq' as const,
					value: id
				}))
			};
			return this.inverted ? { $not: or } : or;
		},
		isSelected() {
			return (id: string): boolean => {
				return this.inverted ? !this.selected.includes(id) : this.selected.includes(id);
			}
		}
	},

	actions: {
		setSelection(id: string, selected: boolean) {
			if (selected !== this.inverted && !this.selected.includes(id)) {
				this.selected.push(id);
			} else if (selected === this.inverted && this.selected.includes(id)) {
				let idx = this.selected.indexOf(id);
				this.selected.splice(idx, 1);
			}
		},
		setInverted(inv: boolean) {
			this.inverted = inv;
			this.selected = [];
		},
		reset() {
			this.setInverted(false);
		}
	},
});
